(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[613],{

/***/ 20438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/locations",
      function () {
        return __webpack_require__(25000);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 15171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4340);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15378);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);




const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
const RangePickerBox = (param)=>{
    let { className , rangePickerClassName , onClear , ...props } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative max-w-[400px] " + (className || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RangePicker, {
                placeholder: [
                    t("Start date"),
                    t("End date")
                ],
                allowClear: false,
                picker: "date",
                inputReadOnly: true,
                format: "YYYY-MM-DD",
                className: "h-[40px] text-[16px] w-full max-w-[400px] " + (rangePickerClassName || ""),
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "text-[#D9D9D9] absolute z-[1] translate-y-[-50%] right-[36px] top-[50%] cursor-pointer hover:text-[#bfbfbf]",
                onClick: (e)=>{
                    e.stopPropagation();
                    onClear === null || onClear === void 0 ? void 0 : onClear(e);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RangePickerBox);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 25000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51964);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(11057);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_google_maps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33458);
/* harmony import */ var react_google_maps_lib_components_addons_MarkerClusterer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88797);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(66242);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1954);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15378);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(12845);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57381);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(60770);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29061);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95629);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34745);
/* harmony import */ var src_components_RangePickerBox__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15171);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(82017);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74743);













const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;
// request









// https://maps.googleapis.com/maps/api/geocode/json?latlng=-31.09426446332877,150.9346199539215&key=AIzaSyCkRXX3doVacVKRHM-oECpLRgC0LNtVkxw
const POSITION = (/* unused pure expression or super */ null && ([]));
const runScopedTask = (task)=>{
    task === null || task === void 0 ? void 0 : task.catch((error)=>{
        if ((error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED" && (error === null || error === void 0 ? void 0 : error.name) !== "CanceledError") ;
    });
};
function GPS() {
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    let Advanced = window.localStorage.getItem("currentDevice");
    Advanced = Advanced == null || Advanced != "{}" ? false : true;
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const reloadRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const advancedGpsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const setLocationRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_13__/* .useDispatch */ .I0)();
    // 查询设备
    const [bgdata, setBgdata] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [mapdata, setMapdata] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [mapCenter, setMapCenter] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        lat: 40.7143528,
        lng: -74.0059731
    });
    const [zoom, setZoom] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(15);
    const [positiondata, setPositiondata] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [mapPositiondata, setMapPositiondata] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [preViewImageOpen, setPerViewImageOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [preViewImageUrl, setPerViewImageUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) //正在加载获取数据
    ;
    // 移动端选择
    const [switchTags, setSwitchTags] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("1");
    // 初始值设置为不是移动端
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const ua = navigator.userAgent.toLowerCase();
    const agents = [
        "iphone",
        "ipad",
        "ipod",
        "android",
        "linux",
        "windows phone"
    ];
    const isMobileFun = ()=>{
        for(let i = 0; i < agents.length; i++){
            if (ua.indexOf(agents[i]) !== -1) {
                setIsMobile(true);
            }
        }
    };
    // 获取地理位置
    let location = async (latitude, longitude, signal)=>{
        try {
            let result = await (0,axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                url: "".concat("https://api.bigdatacloud.net/data/reverse-geocode-client", "?latitude=").concat(latitude, "&longitude=").concat(longitude),
                method: "get",
                signal
            });
            let location = "".concat(result.data.countryName, " ").concat(result.data.city, " ").concat(result.data.locality);
            return "".concat(location);
        } catch (error) {
            return "";
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("GPS location");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_14__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_14__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    const [page, setPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [flag, setFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // 分页处理
    const onChangePage = async (hide)=>{
        setPage(page + 1);
    };
    // 获取基础gps
    let basicGps = async function(page, pageSize) {
        let scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : scopeRef.current;
        var ref, ref1;
        if (!scope) return;
        const { context , signal , isCurrent  } = scope;
        setFlag(true);
        let params = {
            category: "LOCATION",
            offset: page,
            limit: pageSize,
            deviceUdid: (context === null || context === void 0 ? void 0 : context.username) || ""
        };
        startTime == "" ? null : params.startTime = dayjs__WEBPACK_IMPORTED_MODULE_8___default()(dayjs__WEBPACK_IMPORTED_MODULE_8___default()(startTime).format("YYYY-MM-DD 00:00:00")).unix() * 1000;
        endTime == "" ? null : params.endTime = dayjs__WEBPACK_IMPORTED_MODULE_8___default()(dayjs__WEBPACK_IMPORTED_MODULE_8___default()(endTime).format("YYYY-MM-DD 23:59:59")).unix() * 1000;
        let response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_10__/* .getLocalAndroidAll */ .gH)({
            username: ((ref = JSON.parse(localStorage.getItem("userData") || "{}")) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
            params
        }, {
            signal
        });
        if (!isCurrent()) return;
        let result = response.data.contents;
        if (result != null) {
            result = positiondata.concat(response.data.contents);
            setTotal(response.data.totalCount);
        }
        if ((result === null || result === void 0 ? void 0 : result.length) > 0) {
            setMapCenter({
                lat: result[0].latitude,
                lng: result[0].longitude
            });
        }
        let newArr = result;
        if (result != null) {
            localStorage.removeItem("gpsLocations");
            // 先落点位并结束首屏 loading，地址反查异步补齐（避免 ContentLoading 卡整卡）
            let positionDataList = result.map((item, i)=>({
                    ...item,
                    id: i + 1,
                    lat: item.latitude,
                    lng: item.longitude
                }));
            setFlag(false);
            setPositiondata(positionDataList);
            setMapPositiondata(positionDataList);
            setMapdata(result[0]);
            setIsLoading(false);
            for(let i = 0; i < newArr.length; i++){
                if (typeof newArr[i].position == "undefined") {
                    newArr[i].position = await location("".concat(result[i].latitude), "".concat(result[i].longitude), signal);
                    if (!isCurrent()) return;
                // newArr[i].position = '50'
                }
                newArr[i].id = i + 1;
            }
            positionDataList = result.map((item)=>{
                return {
                    ...item,
                    lat: item.latitude,
                    lng: item.longitude
                };
            });
            setPositiondata(positionDataList);
            setMapPositiondata(positionDataList);
        // 未使用此属性
        // setBgdata(positionDataList[0].id)
        } else {
            setFlag(false);
            setIsLoading(false);
        }
    };
    // 获取高级gps
    let advancedGps = async function(page, pageSize) {
        let scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : scopeRef.current;
        var ref, ref1;
        if (!scope) return;
        const { context , signal , isCurrent  } = scope;
        setFlag(true);
        let params = {
            category: "LOCATION",
            offset: page,
            limit: pageSize,
            deviceUdid: (context === null || context === void 0 ? void 0 : context.username) || ""
        };
        startTime == "" ? null : params.startTime = dayjs__WEBPACK_IMPORTED_MODULE_8___default()(dayjs__WEBPACK_IMPORTED_MODULE_8___default()(startTime).format("YYYY-MM-DD 00:00:00")).unix() * 1000;
        endTime == "" ? null : params.endTime = dayjs__WEBPACK_IMPORTED_MODULE_8___default()(dayjs__WEBPACK_IMPORTED_MODULE_8___default()(endTime).format("YYYY-MM-DD 23:59:59")).unix() * 1000;
        let response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_10__/* .getLocalAndroidAll */ .gH)({
            username: ((ref = JSON.parse(localStorage.getItem("userData") || "{}")) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
            params
        }, {
            signal
        });
        if (!isCurrent()) return;
        setFlag(false);
        let result = response.data.contents;
        if (result != null) {
            result = positiondata.concat(response.data.contents);
            setTotal(response.data.totalCount);
        }
        if ((result === null || result === void 0 ? void 0 : result.length) > 0) {
            setMapCenter({
                lat: result[0].latitude,
                lng: result[0].longitude
            });
        }
        // let newArr = result.filter((obj, index, self) => {
        //   console.log(obj, index, self, 456)
        //   return index === self.findIndex(o => o.timeStamp === obj.timeStamp)
        // })
        let newArr = result;
        if (result != null) {
            localStorage.removeItem("gpsLocations");
            // 先落点位并结束首屏 loading，地址反查异步补齐（避免 ContentLoading 卡整卡）
            let positionDataList = newArr.map((item, i)=>({
                    ...item,
                    id: i + 1,
                    lat: item.latitude,
                    lng: item.longitude
                }));
            setPositiondata(positionDataList);
            setMapPositiondata(positionDataList);
            setMapdata(result[0]);
            setIsLoading(false);
            for(let i = 0; i < newArr.length; i++){
                if (typeof newArr[i].position == "undefined") {
                    newArr[i].position = await location("".concat(result[i].latitude), "".concat(result[i].longitude), signal);
                    if (!isCurrent()) return;
                // newArr[i].position = 10
                }
                newArr[i].id = i + 1;
            }
            positionDataList = newArr.map((item)=>{
                return {
                    ...item,
                    lat: item.latitude,
                    lng: item.longitude
                };
            });
            setPositiondata(positionDataList);
            setMapPositiondata(positionDataList);
        // 未使用此属性
        // setBgdata(positionDataList[0].id)
        } else {
            setIsLoading(false);
        }
    };
    // 选择日期
    const [startTime, setStartTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [endTime, setEndTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        setPositiondata([]);
        runScopedTask((ref = advancedGpsRef.current) === null || ref === void 0 ? void 0 : ref.call(advancedGpsRef, 0, 30, scopeRef.current));
    }, [
        startTime
    ]);
    const setLocation = async function(data) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current;
        if (!scope) return;
        // 判断是要不要获取高级版gps
        if (Advanced) {
            if (page === 1 && positiondata.length === 0) {
                //首次加载10
                await basicGps((page - 1) * 30, 10, scope);
            } else if (positiondata.length === 10) {
                //首次获取完 再取20
                await basicGps((page - 1) * 30, 20, scope);
            } else {
                //手动点击
                await basicGps((page - 1) * 30, 30, scope);
            }
        } else {
            if (page === 1 && positiondata.length === 0) {
                //首次加载10
                await advancedGps((page - 1) * 30, 10, scope);
            } else if (positiondata.length === 10) {
                //首次获取完 再取20
                await advancedGps((page - 1) * 30, 20, scope);
            } else {
                //手动点击
                await advancedGps((page - 1) * 30, 30, scope);
            }
        }
    };
    advancedGpsRef.current = advancedGps;
    setLocationRef.current = setLocation;
    reloadRef.current = (scope)=>{
        runScopedTask(setLocation(undefined, scope));
        isMobileFun();
    };
    // 设备切换时重置地图与轨迹数据并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_16__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((_, scope)=>{
        var ref;
        scopeRef.current = scope;
        setPage(1);
        setTotal(0);
        setFlag(false);
        setPositiondata([]);
        setMapPositiondata([]);
        setMapdata(null);
        setStartTime("");
        setEndTime("");
        setIsLoading(true);
        (ref = reloadRef.current) === null || ref === void 0 ? void 0 : ref.call(reloadRef, scope);
    }, []));
    //首次取完 再取20（只依赖条数，避免地址反查二次 set 重复拉数）
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (positiondata.length === 10) {
            var ref;
            runScopedTask((ref = setLocationRef.current) === null || ref === void 0 ? void 0 : ref.call(setLocationRef));
        }
    }, [
        positiondata.length
    ]);
    const [mapRef, setMapRef] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const onMapLoad = (map)=>{
        const bounds = new window.google.maps.LatLngBounds();
        for(let i = 0; i < positiondata.length; i++){
            bounds.extend(positiondata[i]);
        }
        map.fitBounds(bounds);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (page > 1) runScopedTask((ref = setLocationRef.current) === null || ref === void 0 ? void 0 : ref.call(setLocationRef, undefined, scopeRef.current));
    }, [
        page
    ]);
    // 检测gps地图加载是否完毕
    const [isLeafletLoaded, setIsLeafletLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let active = true;
        let timerId;
        const checkLeafletLoaded = ()=>{
            if (!active) return;
            if (typeof L !== "undefined") {
                setIsLeafletLoaded(true);
            } else {
                timerId = setTimeout(checkLeafletLoaded, 100);
            }
        };
        checkLeafletLoaded();
        return ()=>{
            active = false;
            if (timerId) clearTimeout(timerId);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isLeafletLoaded && switchTags == "1") {
            if (mapPositiondata.length !== 0) return;
            var mapContainer = document.getElementById("LeafletMap");
            if (mapContainer) {
                var parent = mapContainer.parentNode;
                parent.removeChild(mapContainer);
            }
            // 获取父元素
            var leafletContainer = document.getElementById("leaflet");
            if (leafletContainer) {
                // 创建子元素 div
                var mapDiv = document.createElement("div");
                mapDiv.id = "LeafletMap";
                // 将子元素添加到父元素中
                leafletContainer.appendChild(mapDiv);
            }
            // 创建地图容器并初始化地图
            const leafletMap = L.map("LeafletMap").setView([
                51.505,
                -0.09
            ], 13);
            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                maxZoom: 19
            }).addTo(leafletMap);
            return ()=>leafletMap.remove();
        }
    }, [
        isLeafletLoaded,
        mapPositiondata.length,
        switchTags
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isLeafletLoaded && switchTags == "1") {
            if (mapPositiondata.length !== 0) {
                var mapContainer = document.getElementById("LeafletMap");
                if (mapContainer) {
                    var parent = mapContainer.parentNode;
                    parent.removeChild(mapContainer);
                }
                // 获取父元素
                var leafletContainer = document.getElementById("leaflet");
                if (leafletContainer) {
                    // 创建子元素 div
                    var mapDiv = document.createElement("div");
                    mapDiv.id = "LeafletMap";
                    // 将子元素添加到父元素中
                    leafletContainer.appendChild(mapDiv);
                }
                // 创建地图容器并初始化地图
                const leafletMap = L.map("LeafletMap").setView([
                    mapPositiondata[0].lat,
                    mapPositiondata[0].lng
                ], mapPositiondata.length == 1 ? 18 : 13);
                L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                    maxZoom: 19
                }).addTo(leafletMap);
                /* 坐标icon */ const customIcon = L.icon({
                    iconUrl: "https://demo.mobilespy.io/assets/images/icons/map-marker.svg",
                    iconSize: [
                        50,
                        50
                    ],
                    iconAnchor: [
                        16,
                        32
                    ]
                });
                // 创建一个MarkerClusterGroup对象，自定义聚合图标
                const markerCluster = new L.MarkerClusterGroup({
                    iconCreateFunction: function(cluster) {
                        var childCount = cluster.getChildCount();
                        var customIconHtml = '<div class="custom-cluster-icon">' + '<img src="/images/gps/m2.png" class="custom-cluster-icon">' + '<div class="cluster-count">' + childCount + "</div>" + "</div>";
                        return L.divIcon({
                            html: customIconHtml,
                            className: "custom-cluster-wrapper",
                            iconSize: [
                                50,
                                50
                            ]
                        });
                    }
                });
                // 添加标记到MarkerClusterGroup
                let coordinates = [];
                // 每个标记的弹出框内容
                let popupContents = [];
                mapPositiondata.forEach((item)=>{
                    coordinates.push([
                        item.lat,
                        item.lng
                    ]);
                });
                mapPositiondata.forEach((item)=>{
                    popupContents.push(item.position);
                });
                // 遍历坐标数组并添加标记到MarkerClusterGroup
                coordinates.forEach(function(coord, index) {
                    var marker = L.marker(coord, {
                        icon: customIcon
                    });
                    // 为每个标记添加点击事件和不同的弹出框内容
                    marker.bindPopup(popupContents[index]);
                    marker.on("click", function() {
                        leafletMap.setView(coord, 20) // 设置视图以当前坐标为中心，缩放级别为16（根据需要进行调整）
                        ;
                    });
                    markerCluster.addLayer(marker);
                });
                leafletMap.addLayer(markerCluster);
                // 获取标记的坐标
                var latlngs = coordinates.map(function(coord) {
                    return L.latLng(coord[0], coord[1]);
                });
                // 自定义连线的样式
                var customLineStyle = {
                    color: "blue",
                    weight: 2,
                    opacity: 0.7 // 线的不透明度
                };
                // 创建Polyline对象并将其添加到地图，应用自定义样式
                L.polyline(latlngs, customLineStyle).addTo(leafletMap);
                // 为MarkerClusterGroup添加点击事件
                markerCluster.on("clusterclick", function(event) {
                    // 获取点击的聚合的中心点坐标
                    var clusterCenter = event.latlng;
                    // 放大地图到最大缩放级别
                    leafletMap.setView(clusterCenter, leafletMap.getMaxZoom());
                });
                // 为MarkerClusterGroup添加点击事件
                return ()=>leafletMap.remove();
            }
        }
    }, [
        isLeafletLoaded,
        mapPositiondata,
        switchTags
    ]);
    const indexMarkers = (row)=>{
        setMapPositiondata([
            row
        ]);
        if (isMobile) {
            setSwitchTags("1");
        }
    };
    const GpsList = ()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-[40%] Mlg:w-full Bxl:h-[calc(var(--vh2)*100-158px)] Bxls:Headers5:h-[calc(var(--vh2)*100-213px)] Header5:big:h-[calc(var(--vh2)*100-278px)] bigs:h-[calc(var(--vh2)*100-338px)] overflow-auto items-center border-[#e6e7ec] border-r-[1px] tb-2 gps-time-line",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-2",
                    style: {
                        padding: "10px",
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            mode: "left",
                            items: positiondata.map((item)=>{
                                return {
                                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                style: {
                                                    color: "#6F6F6F",
                                                    fontSize: "13px"
                                                },
                                                children: dayjs__WEBPACK_IMPORTED_MODULE_8___default()(item.timeStamp).format("YY-MM-DD")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                style: {
                                                    color: "#6F6F6F",
                                                    fontSize: "13px"
                                                },
                                                children: dayjs__WEBPACK_IMPORTED_MODULE_8___default()(item.timeStamp).format("h:mm a")
                                            })
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        onClick: ()=>indexMarkers(item),
                                        style: {
                                            // backgroundColor: item.id === bgdata ? '#EDEFF5' : '',
                                            cursor: "pointer",
                                            borderRadius: "10px",
                                            padding: "10px",
                                            paddingTop: "0px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                style: {
                                                    marginTop: "10px"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    style: {},
                                                    children: item.position
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                style: {
                                                    marginTop: "8px",
                                                    color: "#6F6F6F",
                                                    fontSize: "13px"
                                                },
                                                children: [
                                                    "GPS:",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        style: {
                                                            marginLeft: "4px"
                                                        },
                                                        children: [
                                                            item.lat.toFixed(6),
                                                            ",",
                                                            item.lng.toFixed(6)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            item.positionType == "exif" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                style: {
                                                    marginTop: "8px",
                                                    display: "flex"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    onClick: (e)=>{
                                                        setPerViewImageOpen(true);
                                                        setPerViewImageUrl("https://cos.spyx.com/" + item.sourceRefThumb);
                                                    },
                                                    src: item.sourceRefThumb == "" ? "https://cos.spyx.com/" + item.sourceRef : "https://cos.spyx.com/" + item.sourceRefThumb,
                                                    width: 60,
                                                    height: 60,
                                                    alt: "img",
                                                    style: {}
                                                })
                                            }) : null
                                        ]
                                    })
                                };
                            })
                        }),
                        flag ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {})
                        }) : null,
                        !flag && (positiondata.length > 0 || isLoading) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center",
                                padding: "20px 0"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                onClick: onChangePage,
                                children: t("load more")
                            })
                        }) : null
                    ]
                }),
                positiondata.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center px-3 absolute inset-0 top-[-20%] flex justify-center items-center",
                    children: [
                        t("It appears theres no data to show here yet"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("If data exists it may take up to 1 hour to download and appear"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("We suggest checking back in a little while")
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                className: "relative",
                children: [
                    isLoading && positiondata.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {})
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "lg:flex lg:flex-col Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]",
                        children: [
                            !Advanced ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-between items-center px-[14px] pt-[15px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mr-[10px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_RangePickerBox__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    value: [
                                                        startTime,
                                                        endTime
                                                    ],
                                                    onChange: (e)=>{
                                                        if (e && e.length === 2) {
                                                            ;
                                                            setStartTime(e[0]);
                                                            setEndTime(e[1]);
                                                        } else {
                                                            setStartTime(null);
                                                            setEndTime(null);
                                                        }
                                                        setPositiondata([]);
                                                        setMapPositiondata([]);
                                                    },
                                                    onClear: ()=>{
                                                        setStartTime(null);
                                                        setEndTime(null);
                                                        setPositiondata([]);
                                                        setMapPositiondata([]);
                                                    }
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-[96px] h-[36px] flex rounded-[18px] bg-[#EAEAEA] p-[2px] lg:hidden",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex-1 flex justify-center items-center rounded-[15px]",
                                                style: {
                                                    backgroundColor: switchTags == 1 ? "#FFF" : ""
                                                },
                                                onClick: ()=>{
                                                    setSwitchTags(1);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    src: switchTags == 1 ? "/images/gps/gps-active.svg" : "/images/gps/gps.svg",
                                                    width: 24,
                                                    height: 24,
                                                    alt: "date"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex-1 flex justify-center items-center rounded-[15px]",
                                                style: {
                                                    backgroundColor: switchTags == 2 ? "#FFF" : ""
                                                },
                                                onClick: ()=>{
                                                    setSwitchTags(2);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    src: switchTags == 2 ? "/images/gps/time-active.svg" : "/images/gps/time.svg",
                                                    width: 24,
                                                    height: 24,
                                                    alt: "date"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "lg:flex mt-[15px]",
                                children: [
                                    isMobile ? switchTags == "2" ? GpsList() : null : GpsList(),
                                    isMobile && switchTags == "3" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[calc(var(--vh2)*100-250px)] flex justify-center items-center px-[18px] pb-[18px]",
                                        children: "Application error: a client-side exception has occurred (see the browser console for more information)."
                                    }),
                                    isMobile ? switchTags == "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        style: {
                                            height: "var(--vh2)*100",
                                            width: "100%"
                                        },
                                        className: " gps-map",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "h-[58px] items-center flex w-full px-[14px] mx-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-[30px] h-[30px] bg-[#edeff3] items-center flex rounded-full",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                            src: "/images/gps/gps-active.svg",
                                                            alt: "gps",
                                                            width: 18,
                                                            height: 18,
                                                            className: "mx-auto"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "ml-[13px]",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-[#334062] text-[15px] font-[600]",
                                                            children: mapdata && mapdata.position && mapdata.position
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full h-[91%] p-[1px] GPS",
                                                id: "leaflet",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    id: "LeafletMap",
                                                    style: {
                                                        height: "100%",
                                                        width: "100%"
                                                    }
                                                })
                                            })
                                        ]
                                    }) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        style: {
                                            height: "var(--vh2)*100",
                                            width: "100%"
                                        },
                                        className: "Mlg:border-t-[1px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "h-[60px] items-center flex w-full px-[14px] mx-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-[40px] h-[40px] bg-[#edeff3] items-center flex rounded-full",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                                                            icon: "ic:baseline-location-on",
                                                            width: 20,
                                                            height: 20,
                                                            className: "mx-auto"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "ml-4",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-[#334062] font-bold text-opacity-80",
                                                            children: mapdata && mapdata.position && mapdata.position
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full h-[calc(var(--vh2)*100-286px)] p-[1px] GPS",
                                                id: "leaflet",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    id: "LeafletMap",
                                                    style: {
                                                        height: "100%",
                                                        width: "100%"
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                title: "",
                open: preViewImageOpen,
                onCancel: ()=>{
                    setPerViewImageOpen(false);
                },
                width: "540px",
                footer: [],
                zIndex: 1200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        padding: "14px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        src: preViewImageUrl,
                        width: 200,
                        height: 200,
                        style: {
                            width: "460px",
                            height: "auto"
                        },
                        alt: "preview"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (GPS);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,5378,2862,770,2607,210,1964,7701,9774,2888,179], function() { return __webpack_exec__(20438); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);